import { createDomain } from 'effector'

const domain = createDomain('entities.registration.leadWelcomeDrawer')

export const showLeadWelcomeDrawer = domain.createEvent()
export const hideLeadWelcomeDrawer = domain.createEvent()

export const $isLeadWelcomeDrawerShow = domain
  .createStore(false)
  .on(showLeadWelcomeDrawer, () => true)
  .on(hideLeadWelcomeDrawer, () => false)
